module.exports = __webpack_public_path__ + "img/图1-25等分线段AB.e3d3ccbd.jpg";